import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../hooks/useTexts'

export function Header() {
  const texts = useTexts()

  return <ModalHeader title={texts.header.title} />
}
